:host {
  display: block;

  --sy-icon-color: var(--sy-primary-contrast, #fff);
  --sy-text-small-font-size: 12.8px;

  #title-container {
    margin-bottom: 1rem;
  }

  .link {
    color: var(--sy-icon-color, #fff);
    text-decoration: none;
  }

  sy-grid {
    sy-cell {

      display: flex;
      flex-direction: column;

      .icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        color: var(--sy-icon-color, #fff);
        text-decoration: none;
        background-color: #282c2f;
        border-color: #282c2f;
        border-radius: 6.4px;
        --sy-icon-stroke-width: 1px;

        &:hover,
        &:focus {
          background: #16191a;
          border-color: #111213;
        }

        &::before {
          display: block;
          padding-top: 100%;
          content: "";
        }

        &:focus {
          box-shadow: 0 0 0 .2rem rgb(72 76 78 / 50%);
        }

      }

      .name {
        text-decoration: none;
        color: unset;
        margin: 2px auto 0 auto;
        text-align: center;
        &:hover,
        &:focus {
          color: transparentize($color: #fff, $amount: 0.25);
        }
      }

      .active {
        background: var(--sy-accent, #2068c7);
        border-color: var(--sy-accent, #2068c7);

        &:hover,
        &:focus {
          color: #fff;
          background: var(--sy-accent-hover, #237ad9);
        }

        &:active {
          background-color: var(--sy-accent-active, #288cec);
        }
      }
    }
  }
}
